import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { isDepositTokenApproved, SupportedDex } from '@ichidao/ichi-vaults-sdk';
import { JsonRpcProvider, Web3Provider } from '@ethersproject/providers';
import { useAddress } from '@thirdweb-dev/react';
import { parseEther } from 'ethers/lib/utils';

async function fetcher(
  address: string | undefined,
  amount: string,
  vaultId: string | null | undefined
) {
  if (!address || !amount || !vaultId) {
    return false;
  }

  const dex = SupportedDex.Kim;

  const web3Provider = new Web3Provider(window.web3.currentProvider);

  const res = await isDepositTokenApproved(
    address,
    0, // token idx can be 0 or 1
    parseEther(amount),
    vaultId,
    web3Provider,
    dex
  );

  return res;
}

export function useIsDepositTokenApproved(
  amount: string,
  vaultId: string | null
) {
  const address = useAddress();

  return useQuery<boolean | undefined>(
    [QueryKeys.IS_DEPOSIT_TOKEN_APPROVED, address, amount, vaultId],
    () => fetcher(address, amount, vaultId),
    {
      enabled: !!(address && amount && vaultId)
    }
  );
}
